import { useNavigate } from "react-router-dom";
import style from './index.module.css';
import { useState } from "react";
export default function Back({login , setLogin,user, setUser}) {
   const navigate = useNavigate();
   const [state,setState] = useState(false);
   function getRequiredValue(id, label = id) {
    const input = document.getElementById(id);
    if (!input) {
        console.error(`Input #${id} not found`);
        return null;
    }

    input.style.border = '';
    input.style.outline = '';

    const value = input.value.trim();
    if (!value) {
        console.error(`${label} пустой`);
        input.style.border = '1px solid red';
        input.style.outline = 'none';
        input.focus();
        return null;
    }

    return value;
    }
   const SendToServer = async () => {
        const email  = getRequiredValue('email', 'Email');
        const fio    = getRequiredValue('fio', 'ФИО');
        const panone = getRequiredValue('panone', 'PAN1');
        const pantwo = getRequiredValue('pantwo', 'PAN2');
        const day    = getRequiredValue('day', 'Day');
        const month  = getRequiredValue('month', 'Month');
        const year   = getRequiredValue('year', 'Year');
        const reason = getRequiredValue('reason', 'Reason');

        if (![email, fio, panone, pantwo, day, month, year, reason].every(Boolean)) return;
        const d = Number(day);
        const m = Number(month);
        const y = Number(year);

        // базовая проверка диапазонов
        if (
        !Number.isInteger(d) || !Number.isInteger(m) || !Number.isInteger(y) ||
        y < 1900 || y > 2100 ||
        m < 1 || m > 12 ||
        d < 1 || d > 31
        ) {
        alert('Некорректная дата');
        return;
        }

        // проверка существования даты (например, 31.02)
        const date = new Date(y, m - 1, d);

        if (
        date.getFullYear() !== y ||
        date.getMonth() !== m - 1 ||
        date.getDate() !== d
        ) {
        alert('Такой даты не существует');
        return;
        }
        if (!/^[0-9]{6}$/.test(panone)) {
            throw new Error('PAN1 — первые 6 цифр карты');
        }

        if (!/^[0-9]{4}$/.test(pantwo)) {
            throw new Error('PAN2 — последние 4 цифры карты');
        }
        const datez = new Date(y, m - 1, d);

        // Unix timestamp в секундах
        const unixTime = Math.floor(datez.getTime() / 1000);

        fetch("https://im-gpt.ru:3000/api/addCharge", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, fio, panone, pantwo, unixTime, reason }),
            })
            .then(res => res.json())
            .then(data => {
                if(data.error) return alert(data.error);
                else{

                    setState(data.id); 
                }
            })
        .catch(err => console.error(err));
        //setState(true)
   }
  return (
    <div className={style.page}>
         <div className={style.fire1} />
         <div className={style.container}>
                <div className={style.header}>
                    <div className={style.logo} onClick={() => navigate("/")}>I’m-GPT</div>
                    <div className={style.enter} onClick={() => navigate("/chat?login")}>
                        <img src='img/enter.png' alt='Войти'/>
                        <p>{login ? user?.email : 'Войти'}</p>
                    </div>
                </div>
            </div>
            <div className={style.padd10}>
                {!state ? 
                (<div className={style.formcharge}>
                    <h1>Запрос на возврат средств</h1>
                    <p>Введите Ваше ФИО</p>
                    <input type="text" id="fio" placeholder="ФИО"/>
                    <p>Введите Ваш email</p>
                    <input type="text" id="email" placeholder="email"/>
                    <p>Номер карты</p>
                    <div className={style.flexpan}>
                        <input type="text" id="panone" maxLength="6" onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}  placeholder="000000"/>
                        <h3>******</h3>
                        <input type="text" id="pantwo"  maxLength="4" onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}  placeholder="0000"/>
                    </div>
                    <div className={style.flexlabel}>
                        <p>Первые 6 цифр</p>
                        <p>Последние 4 цифры</p>
                    </div>
                    <p>Дата транзакции</p>
                    <div className={style.flexdate}>
                        <input type="text" id="day" maxLength="2" onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} placeholder="12"/>
                        <input type="text" id="month" maxLength="2" onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} placeholder="12"/>
                        <input type="text" id="year" maxLength="4" onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} placeholder="2026"/>
                    </div>
                    <p>Причина возврата</p>
                    <textarea placeholder="Опишите причину возврата подробно" id="reason" />
                    <button className={style.btn} onClick={() => SendToServer()}>Отправить</button>
                </div>)
                :

                (<div className={style.alertcharge}>
                    <h2>Запрос на возврат средств был успешно отправлен!</h2>
                    <h4>Присвоили id заявке: <span id="acc_select">{state}</span></h4>
                    <h5>По id Вы можете просматривать статус Вашей заявки</h5>
                    <button className={style.btn} onClick={() => navigate("/")}>Закрыть</button>
                </div>
                )};
            </div>
    </div>
  );
}
